import { useSyncExternalStore } from 'react';
import { getMomentAccountId, subscribeMomentAccount } from '../moments/accountScope';
import { loadProfile, profileStorageKey } from './profile';

let cachedUser: string | null | undefined;
let cachedAvatar: string | undefined;
let cachedStorage: string | null | undefined;
function snapshot(): string | undefined {
  const userId = getMomentAccountId();
  let stored: string | null = null;
  try { stored = userId ? localStorage.getItem(profileStorageKey(userId)) : null; } catch { /* Missing storage falls back to the default avatar. */ }
  if (cachedUser !== userId || cachedStorage !== stored) {
    cachedUser = userId;
    cachedStorage = stored;
    try { cachedAvatar = userId ? loadProfile(userId)?.avatar : undefined; }
    catch { cachedAvatar = undefined; }
  }
  return cachedAvatar;
}
function subscribe(onChange: () => void): () => void {
  const refresh = () => { cachedUser = undefined; onChange(); };
  const storage = (event: StorageEvent) => {
    const userId = getMomentAccountId();
    if (event.key === null || (userId && event.key === profileStorageKey(userId))) refresh();
  };
  const unsubscribe = subscribeMomentAccount(refresh);
  window.addEventListener('zhixin:profile-saved', refresh);
  window.addEventListener('storage', storage);
  return () => {
    unsubscribe();
    window.removeEventListener('zhixin:profile-saved', refresh);
    window.removeEventListener('storage', storage);
  };
}
/** All message avatars share one account-scoped snapshot without repeated identity requests. */
export function useUserAvatar(): string | undefined {
  return useSyncExternalStore(subscribe, snapshot, () => undefined);
}
